var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { NoData } from './NoData';
import { SonarText } from './text';
import { Table } from 'antd';
import React, { forwardRef, useMemo } from 'react';
const TableComponent = (_a, ref) => {
    var { columns, locale } = _a, rest = __rest(_a, ["columns", "locale"]);
    const managedColumns = useMemo(() => columns === null || columns === void 0 ? void 0 : columns.map((column) => (Object.assign(Object.assign({}, column), { ellipsis: false, render: (value, object, index) => {
            const base = column.render ?
                column.render(value, object, index) :
                object[column.dataIndex];
            return column.ellipsis ?
                React.createElement(SonarText, { ellipsis: {
                        tooltip: {
                            children: base,
                            placement: 'bottom',
                            showArrow: true
                        }
                    } }, base) :
                base;
        } }))), [columns]);
    return (React.createElement(Table, Object.assign({ locale: Object.assign({ emptyText: React.createElement(NoData, null) }, locale) }, rest, { columns: managedColumns, ref: ref })));
};
export const SonarTable = forwardRef(TableComponent);
